import axios from 'axios'
import type { PublicKey } from '@solana/web3.js'
import config from './config'

const apiBase = `${config.server || ''}${config.baseURL}`

/**
 * Prove control of the connected wallet and migrate the account from virtual → real Solana pubkey.
 */
export async function linkVirtualAccountToSolanaWallet(
  virtualWalletAddress: string,
  publicKey: PublicKey,
  signMessage: (message: Uint8Array) => Promise<Uint8Array>,
): Promise<{ success: true } | { success: false; message: string }> {
  const sol = publicKey.toBase58()
  const ts = Date.now()
  const message = `Eclipsera link wallet\nAccount: ${virtualWalletAddress}\nNewSolana: ${sol}\nTimestamp: ${ts}`
  const encoded = new TextEncoder().encode(message)
  const sig = await signMessage(encoded)
  const bytes = new Uint8Array(sig)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i])
  const signatureBase64 = btoa(binary)
  const { data } = await axios.post(
    `${apiBase}/user/link-wallet`,
    { newWalletAddress: sol, message, signatureBase64 },
    { withCredentials: true },
  )
  if (!data?.success) {
    return { success: false, message: data?.message || 'Could not link wallet.' }
  }
  return { success: true }
}
